import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const optionTypeReducer = (state, action) => {
  switch (action.type) {
    case types.SELECTED_HOTEL_ID:
      return "Hotel";

    case types.SELECTED_REGION_ID:
      return "Region";

    case types.SELECTED_CITY_CODE:
      return "City";

    case types.SET_SEARCH_DATA:
      return (
        (action.payload &&
          action.payload.SelectedOption &&
          action.payload.SelectedOption.optionType) ||
        state
      );

    default:
      return state;
  }
};

export default (state = initialState.selectedOption, action) => {
  switch (action.type) {
    case types.UPDATE_SELECTED_OPTION:
      return action.payload;

    case types.CONFIG_SUCCESS:
      return action.payload.selectedOption || state;

    case types.SELECTED_HOTEL_ID:
    case types.SELECTED_REGION_ID:
    case types.SELECTED_CITY_CODE:
      return {
        value: action.payload || state.value,
        optionType: action.payload
          ? optionTypeReducer(state, action)
          : state.optionType
      };

    case types.SET_SEARCH_DATA:
      return (action.payload && action.payload.SelectedOption) || state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/selectedOptionReducer.js